import { render, staticRenderFns } from "./GroupSingleText.vue?vue&type=template&id=bd10441e"
import script from "./GroupSingleText.vue?vue&type=script&lang=js"
export * from "./GroupSingleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports